import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";

/**
 * React wrapper for Bryntum EventList
 */
import React, { Component } from 'react';
import WrapperHelper from './WrapperHelper.js';
import { EventList } from '@bryntum/calendar/calendar.umd';

var BryntumEventList = /*#__PURE__*/function (_Component) {
  _inherits(BryntumEventList, _Component);

  var _super = _createSuper(BryntumEventList);

  function BryntumEventList() {
    var _this;

    _classCallCheck(this, BryntumEventList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.configNames = ['adopt', 'align', 'anchor', 'animateRemovingRows', 'appendTo', 'autoHeight', 'bbar', 'bodyCls', 'centered', 'cls', 'columns', 'config', 'constrainTo', 'contentElementCls', 'contextMenuTriggerEvent', 'defaultBindProperty', 'defaultRegion', 'defaults', 'destroyStore', 'destroyStores', 'disableGridRowModelWarning', 'dock', 'draggable', 'emptyText', 'enableSticky', 'enableTextSelection', 'enableUndoRedoKeys', 'eventFilter', 'features', 'fillLastColumn', 'fixedRowHeight', 'floating', 'footer', 'fullRowRefresh', 'getRowHeight', 'header', 'hideAnimation', 'hideHeaders', 'hideWhenEmpty', 'htmlCls', 'insertBefore', 'insertFirst', 'itemCls', 'lazyItems', 'listeners', 'loadMask', 'loadMaskDefaults', 'loadMaskError', 'localeClass', 'localizableProperties', 'longPressTime', 'maskDefaults', 'masked', 'monitorResize', 'namedItems', 'owner', 'plugins', 'positioned', 'preserveFocusOnDatasetChange', 'preserveScrollOnDatasetChange', 'preventTooltipOnTouch', 'range', 'resizeToFitIncludesHeader', 'responsiveLevels', 'ripple', 'rootElement', 'scrollAction', 'scrollerClass', 'scrollManager', 'selectionMode', 'showAnimation', 'showDirty', 'showRemoveRowInContextMenu', 'strips', 'subGridConfigs', 'syncMask', 'tab', 'tag', 'tbar', 'textAlign', 'textContent', 'title', 'trapFocus', 'weight'];
    _this.propertyConfigNames = ['alignSelf', 'columnLines', 'content', 'data', 'dataset', 'date', 'defaultCalendar', 'disabled', 'events', 'eventStore', 'extraData', 'flex', 'height', 'hidden', 'html', 'id', 'items', 'layout', 'layoutStyle', 'margin', 'maxHeight', 'maxWidth', 'minHeight', 'minWidth', 'onBeforeCellEditStart', 'onBeforeDestroy', 'onBeforeEventDelete', 'onBeforeFinishCellEdit', 'onBeforeHide', 'onBeforeRenderRows', 'onBeforeSetRecord', 'onBeforeShow', 'onBeforeToggleNode', 'onCancelCellEdit', 'onCatchAll', 'onCellClick', 'onCellContextMenu', 'onCellDblClick', 'onCellMouseOut', 'onCellMouseOver', 'onCollapseNode', 'onDestroy', 'onExpandNode', 'onFinishCellEdit', 'onFocusIn', 'onFocusOut', 'onHide', 'onMouseOut', 'onMouseOver', 'onPaint', 'onReadOnly', 'onRenderRows', 'onResize', 'onResponsive', 'onScroll', 'onSelectionChange', 'onShow', 'onStartCellEdit', 'onToggleNode', 'onToolClick', 'project', 'readOnly', 'resources', 'resourceStore', 'rowHeight', 'scrollable', 'store', 'tools', 'tooltip', 'transitionDuration', 'width', 'x', 'y'];
    _this.propertyNames = ['anchorSize', 'isEngineReady', 'isSettingValues', 'isValid', 'record', 'selectedCell', 'selectedRecord', 'selectedRecords', 'state', 'values'];
    _this.instance = undefined;
    _this.element = undefined;
    return _this;
  }

  _createClass(BryntumEventList, [{
    key: "componentDidMount",
    value:
    /**
     * Invoked immediately after a component is mounted (inserted into the tree)
     */
    function componentDidMount() {
      var _WrapperHelper = WrapperHelper(),
          createWidget = _WrapperHelper.createWidget;

      this.instance = createWidget(this);
    } // React component removed, destroy instance

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.instance) {
        this.instance.destroy();
      }
    }
    /**
     * Component about to be updated, from changing a prop using state.
     * React to it depending on what changed and prevent react from re-rendering our component.
     * @param nextProps
     * @param nextState
     * @return {boolean}
     */

  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _WrapperHelper2 = WrapperHelper(),
          shouldComponentUpdate = _WrapperHelper2.shouldComponentUpdate;

      return shouldComponentUpdate(this, nextProps, nextState);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = "b-react-".concat(this.constructor.instanceClass.$name.toLowerCase(), "-container");
      return /*#__PURE__*/React.createElement("div", {
        className: className,
        ref: function ref(element) {
          return _this2.element = element;
        }
      });
    }
  }]);

  return BryntumEventList;
}(Component);

BryntumEventList.instanceClass = EventList;
export { BryntumEventList as default };